/* eslint-disable */
import axios from 'axios';
import { API2_HOST } from '../helpers/urlHelper';
import dayjs from 'dayjs';
import { stillageTypes } from "./stillageDashboard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { Badge, ButtonGroup, Dropdown, DropdownButton } from "react-bootstrap";
import store from 'store';
import { stillageCollections as slice } from 'slices/stillageCollections';

// const API2_HOST = 'https://api2-dev.emplas.co.uk/v1';

const collectionCols = [
    {
        accessor: 'custName',
        Header: 'Customer',
        isVisible: true,
    },
    {
        accessor: 'custTypeDesc',
        Header: 'Customer Type',
        isVisible: true,
    },
    {
        accessor: 'collectionDate',
        Header: 'Collection Date',
        isVisible: true,
        Cell: ({ value }) => (dayjs(value).format('DD/MM/YYYY'))
    },
    {
        accessor: 'collectionNote',
        Header: 'Collection Job No.',
        isVisible: true,
    },
    {
        accessor: 'description',
        Header: 'Notes',
        isVisible: true,
        Cell: ({ value }) => (<span data-tooltip-id="notes-tip" data-tooltip-content={value?.join(', ')} className="d-inline-block text-truncate" style={{ maxWidth: '150px' }}>{value?.join(', ')}</span>)
    },
    {
        accessor: 'stillageNo',
        Header: 'Stillage Nos.',
        isVisible: true,
        Cell: ({ value, row }) => {
            if (row?.original?.collectedData?.length) {
                const nos = [...new Set(row?.original?.collectedData.map(x => x.stillageNo))];
                const data = nos?.map(x => row?.original?.collectedData.find(y => y.stillageNo === x));
                return (
                    <span
                        data-tooltip-id="collected-tip"
                        data-tooltip-content={
                            data?.map(x => `${x.stillageNo} collected on ${dayjs(x.collectedDate).format('DD/MM/YYYY')}: ${x.collectedScannerNotes}`).join('\n')
                        }
                    > {value?.join(', ')}</span>
                )
            }
            return value?.join(', ');
        }
    },
    {
        accessor: 'stillageType',
        Header: 'Stillage Types',
        isVisible: true,
        Cell: ({ row }) => {
            const allTypes = row?.original?.stillageType;
            const stillageTypes = [...new Set(allTypes?.map(x => x.type.text))];

            return <div>
                {(stillageTypes.map(x => {
                    const stillages = allTypes.filter(y => y.type.text === x);
                    const type = stillages[0]?.type;

                    return <div key={x.no} className='text-center'>
                        <span
                            data-tooltip-id="stills-tip"
                            data-tooltip-content={stillages?.map(x => x.no).join(', ')}
                            dangerouslySetInnerHTML={{ __html: type?.label }} />
                        <br />
                    </div>
                }))}
            </div>
        }
    },
    {
        accessor: 'deliveryAddress',
        Header: 'Delivered Address',
        isVisible: true,
    },
    {
        accessor: 'deliveryPostCode',
        Header: 'Delivered Postcode',
        isVisible: true,
    },
    {
        accessor: 'route',
        Header: 'Route',
        isVisible: true,
    },
    {
        Header: 'Manage',
        isVisible: true,
        Cell: ({ row: { original: { collectionNote, stillageNo, collectedData, collectionDate } } }) => {
            return (
                <DropdownButton size='sm' variant="info" as={ButtonGroup} title="Edit">
                    <Dropdown.Item
                        disabled={collectedData?.length === stillageNo?.length}
                        onClick={() => {
                            const stillagesToFit = stillageNo.filter(x => x > 0).filter(x => !collectedData.some(y => y == x));
                            openStillageEditModal('markCollected', { collectionNote, stillagesToFit })
                        }}>
                        Mark Stillage As Collected
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => {
                            const stillagesNotCollected = stillageNo.filter(x => x > 0).filter(x => !collectedData.some(y => y == x));
                            openStillageEditModal('markNotCollected', { collectionNote, stillagesNotCollected })
                        }}>
                        Mark Stillage As Not Collected
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => openStillageEditModal('addStillage', { collectionNote, collectionDate })}>
                        Add Stillage To Collection
                    </Dropdown.Item>
                </DropdownButton>
            )
        }
    }
];

const openStillageEditModal = (key, data) => store.dispatch(slice.actions.openModal({ key, data }));

const buildReqActWidgetTableRow = (data, typeKey) => {
    let actTotal = 0;
    let reqTotal = 0;
    return (
        <>
            <th>Required <br />Actual<br /></th>
            {data?.map((x, i) => {
                const dayData = x[typeKey];
                const success = dayData?.actualCount <= dayData?.estCount;
                const bg = success ? 'success' : 'danger';
                const caret = <FontAwesomeIcon icon={success ? faCaretDown : faCaretUp} />
                actTotal += dayData?.actualCount || 0;
                reqTotal += dayData?.estCount || 0;

                return (
                    <td key={x?.date || i} className="text-center">
                        <Badge className="text-dark" bg="light">{dayData ? dayData?.estCount : '-'}</Badge><br />
                        <Badge className={`text-${dayData?.actualCount ? 'light' : 'dark'}`} bg={dayData?.actualCount ? bg : 'light'}>
                            {dayData?.actualCount ? <>{caret} {dayData?.actualCount}</> : '-'}
                        </Badge>
                    </td>
                )
            })}
            <td>
                <Badge className="text-light" bg="dark">{reqTotal}</Badge><br />
                <Badge className="text-light" bg="dark">{actTotal}</Badge>
            </td>
        </>
    )
};

const buildCollectionWidgetTableRow = (data, typeKey) => {
    let plannedCSOTotal = 0;
    let plannedSFTotal = 0;
    let actualTotal = 0;
    let totalPlanned = 0;
    return (
        <>
            <th>
                Planned (<small>CSO</small>)<br />
                Planned (<small>S&F</small>)<br />
                Total (<small>planned</small>)<br />
                Actual<br />
            </th>

            {data?.map((x, i) => {
                const dayData = x[typeKey];

                const dayPlanned = dayData?.plannedCSO + dayData?.plannedSF;
                const success = dayData?.actualCollected >= dayPlanned;

                const bg = success ? 'success' : 'danger';
                const caret = <FontAwesomeIcon icon={success ? faCaretUp : faCaretDown} />
                plannedCSOTotal += dayData?.plannedCSO || 0;
                plannedSFTotal += dayData?.plannedSF || 0;
                actualTotal += dayData?.actualCollected || 0;
                totalPlanned += dayPlanned || 0;

                return (
                    <td key={x?.date || i} className="text-center">
                        <Badge className="text-dark" bg="light">{dayData?.plannedCSO ? dayData?.plannedCSO : '-'}</Badge><br />
                        <Badge className="text-dark" bg="light">{dayData?.plannedSF ? dayData?.plannedSF : '-'}</Badge><br />
                        <Badge className="text-dark" bg="light">{dayPlanned ? dayPlanned : '-'}</Badge><br />
                        <Badge className={`text-${dayData?.actualCollected ? 'light' : 'dark'}`} bg={dayData?.actualCollected ? bg : 'light'}>
                            {dayData?.actualCollected ? <>{caret} {dayData?.actualCollected}</> : '-'}
                        </Badge>
                    </td>
                )
            })}
            <td>
                <Badge className="text-light" bg="dark">{plannedCSOTotal}</Badge><br />
                <Badge className="text-light" bg="dark">{plannedSFTotal}</Badge><br />
                <Badge className="text-light" bg="dark">{totalPlanned}</Badge><br />
                <Badge className="text-light" bg="dark">{actualTotal}</Badge>
            </td>
        </>
    )
}

const getStillageCollections = async (start, end) => {
    const data = { raw: [], tableData: [] };

    const res = await axios.get(API2_HOST +
        `/stillage-collection/get-collections${start ? '?start=' + start : ''}${start && end ? '&end=' + end : ''}`)
        .catch(err => {
            console.log(err);
            throw new Error(err);
        });

    if (res && res.status === 200) {
        data.raw = res.data;
        data.tableData = Object.keys(res.data)?.reduce((acc, curr) => [...acc, {
            collectionDate: res.data[curr][0].collectionDate,
            collectionNote: res.data[curr][0].collectionNote,
            custName: res.data[curr][0].custName,
            custTypeDesc: res.data[curr][0].custTypeDesc,
            deliveredDate: res.data[curr][0].deliveredDate,
            deliveredFrameId: [...new Set(res.data[curr].map(x => x.deliveredFrameId))],
            deliveredHeaderId: [...new Set(res.data[curr].map(x => x.deliveredHeaderId))],
            deliveredJobNo: [...new Set(res.data[curr].map(x => x.deliveredJobNo))],
            deliveryAddress: res.data[curr][0].deliveryAddress,
            deliveryPostCode: res.data[curr][0].deliveryPostCode,
            description: [...new Set(res.data[curr].map(x => x.description))],
            fbStillageId: [...new Set(res.data[curr].map(x => x.fbStillageId))],
            fittedDate: res.data[curr][0].fittedDate,
            fittingTeam: res.data[curr][0].fittingTeam,
            installDate: res.data[curr][0].installDate,
            plotNo: null,
            route: res.data[curr][0].route,
            stillageNo: [...new Set(res.data[curr].map(x => x.stillageNo))],
            stillageType: res.data[curr].filter((v, i, a) => a.map(({ stillageNo }) => stillageNo).indexOf(v.stillageNo) === i)
                .map(x => {
                    return {
                        no: x.stillageNo,
                        type: stillageTypes[x.stillageType]
                    }
                }),
            collectedData: res.data[curr].filter(x => x.collected).map(x => {
                return { stillageNo: x.stillageNo, collectedDate: x.collectedDate, collectedScannerNotes: x.collectedScannerNotes }
            })
        }], []);
        return data;
    }
    return data;
}

const getStillagePositions = async (start, end) => {
    const res = await axios.get(API2_HOST +
        `/stillage-collection/get-positions${start ? '?start=' + start : ''}${start && end ? '&end=' + end : ''}`)
        .catch(err => {
            console.log(err);
            throw new Error(err);
        });

    if (res && res.status === 200) {
        return res.data;
    }

    return {};
}

const updateStillageCollection = async (jobno, collectionDate, stillageNos, type, reason = "") => {
    if (!stillageNos || !jobno)
        return { message: 'No Job or stillages selected! Please select this before continuing.' };

    const res = await axios.post(API2_HOST + `/stillage-collection/update-stillage-collected`, {
        jobno, stillageNos, collectionDate, type, reason
    });

    if (res && res?.data)
        return res.data;
    else
        return { message: res?.data?.message || 'No response!' };
}

const addStillageToJob = async (jobno, collectionDate, stillageNos) => {
    if (!stillageNos || !jobno)
        return { message: 'No Job or stillages selected! Please select this before continuing.' };

    const res = await axios.post(API2_HOST + `/stillage-collection/add-stillage`, {
        jobno, stillageNos, collectionDate
    });

    if (res && res?.data)
        return res.data;
    else
        return { message: res?.data?.message || 'No response!' };
}

export {
    getStillageCollections,
    getStillagePositions,
    buildReqActWidgetTableRow,
    buildCollectionWidgetTableRow,
    updateStillageCollection,
    addStillageToJob,
    collectionCols
}